import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-free-form-target-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-target-form.component.html',
    styleUrls: ['./free-form-target-form.component.scss'],
    standalone: false
})
export class FreeFormTargetFormComponent {
  #isSubmitted = signal(false);
  #annotationTarget: FlatModels.AnnotationTargetEntityModels.AnnotationTarget | null;
  annotationTargetForm = new FormGroup(
    {
      color: new FormControl(''),
      endType: new FormControl(''),
      endRadius: new FormControl(0),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.AnnotationTargetEntityModels.AnnotationTargetSchema.pick({
          color: true,
          endType: true,
          endRadius: true
        })
      )
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Marker Targets
    this.slideAuthorFacade.currentSelectedSlideFreeFormTarget$.pipe(takeUntilDestroyed()).subscribe((markerTarget) => {
      this.#annotationTarget = structuredClone(markerTarget);
      if (this.#annotationTarget) {
        this.annotationTargetForm.reset(this.#annotationTarget);
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.annotationTargetForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const freeFormTarget = assign(this.#annotationTarget, this.annotationTargetForm.value);
    this.slideAuthorFacade.requestUpdateAnnotationTarget(freeFormTarget, 'history.free_form_update_target').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.annotationTargetForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
  
  onEndTypeChange() {
    if (this.annotationTargetForm.value.endType === FlatModels.AnnotationEntityModels.TipType.enum.circle && (!this.annotationTargetForm.value.endRadius || this.annotationTargetForm.value.endRadius === 0)) {
      this.annotationTargetForm.patchValue({endRadius: 20});
    }
    this.onSubmit();
  }
}
